import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import { withRouter } from "react-router";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import moment from "moment";
import { EstablishmentPlanBadge } from "../../user_requests/components/establishment_plan_badge.component";
import { Api } from "../../utils/api";
import { Invoicexpress } from "../../utils/invoicexpress";
import { Tooltip } from "@material-ui/core";

class PaymentsListTable extends React.Component {
  constructor() {
    super();
    this.goTo = this.goTo.bind(this);
    this.api = new Api();
    this.iexpress = new Invoicexpress();
  }

  goTo(location) {
    this.props.history.push(location);
  }

  render() {
    var { payments } = this.props;
    const { classes } = this.props;
    const { rowsPerPage } = this.props;
    const { showHistoryLink } = this.props;

    console.log(payments);

    return (
      <div className="main-reqlist-container">
        <Paper className={classes.paper}>
          <Table className={classes.table}>
            <TableHead>
              <TableRow>
                <TableCell align="left" className={classes.head}>
                  Entidade
                </TableCell>
                <TableCell align="left" className={classes.head}>
                  Ref. Easypay
                </TableCell>
                <TableCell align="left" className={classes.head}>
                  Equipamento
                </TableCell>
                <TableCell align="left" className={classes.head}>
                  Plano
                </TableCell>
                <TableCell align="left" className={classes.head}>
                  Emissor
                </TableCell>
                <TableCell align="left" className={classes.head}>
                  Utente
                </TableCell>
                <TableCell align="left" className={classes.head}>
                  Data cobrança
                </TableCell>
                <TableCell align="left" className={classes.head}>
                  Valor
                </TableCell>
                <TableCell align="left" className={classes.head}>
                  Modo pagamento
                </TableCell>
                <TableCell align="left" className={classes.head}>
                  Status
                </TableCell>
                <TableCell align="center" className={classes.head}>
                  Fatura
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {payments &&
                payments.slice(0, rowsPerPage).map((payment, idx) => (
                  <TableRow
                    key={payment.row_num}
                    style={
                      idx % 2
                        ? { background: "lightgray" }
                        : { background: "white" }
                    }
                  >
                    <TableCell align="left" style={{ width: "300px" }}>
                      {showHistoryLink && (
                        <>
                          <Tooltip title="Ver histórico">
                            <a
                              href="#"
                              onClick={() =>
                                this.goTo(`/payments/${payment.ep_key}`)
                              }
                            >
                              {payment.entity_name}
                            </a>
                          </Tooltip>
                        </>
                      )}
                      {!showHistoryLink && payment.entity_name}
                    </TableCell>
                    <TableCell align="left">{payment.ep_reference}</TableCell>
                    <TableCell align="left" style={{ width: "300px" }}>
                      {payment.establishment_name}
                    </TableCell>
                    <TableCell align="left" style={{ width: "200px" }}>
                      {payment.plan_name &&
                        payment.ep_payment_type === "RP" && (
                          <EstablishmentPlanBadge plan={payment.plan_name} />
                        )}
                      {!payment.ep_payment_type && "Encaminhamento"}
                    </TableCell>
                    <TableCell align="left">{payment.user_name}</TableCell>
                    <TableCell align="left">{payment.elderly_name}</TableCell>
                    <TableCell align="left" style={{ width: "200px" }}>
                      {moment(payment.payment_at).format("YYYY-MM-DD")}
                    </TableCell>
                    <TableCell align="left">€{payment.ep_value}</TableCell>
                    <TableCell align="left">{payment.payment_method}</TableCell>
                    <TableCell align="left">{payment.ep_status}</TableCell>
                    <TableCell align="center">
                      {payment.invoice_id && (
                        <Tooltip title="Ver fatura">
                          <a
                            href="#"
                            onClick={() =>
                              this.iexpress.openInvoice(
                                payment.invoice_id,
                                payment.invoice_type
                              )
                            }
                          >
                            {payment.invoice_sequence_nr}
                          </a>
                        </Tooltip>
                      )}
                      {!payment.invoice_id && "N/A"}
                    </TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </Table>
        </Paper>
      </div>
    );
  }
}

const styles = (theme) => ({
  root: {
    width: "100%",
    marginTop: theme.spacing.unit * 3,
    overflowX: "auto",
  },
  table: {
    minWidth: 700,
  },
  paper: {
    height: "400px",
    overflowY: "scroll",
  },
  head: {
    backgroundColor: "#104363",
    color: "white",
    position: "sticky",
    top: 0,
    zIndex: 1,
  },
});

PaymentsListTable.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(withRouter(PaymentsListTable));
